import React from 'react'
import {Link} from 'gatsby'
//import parse from "html-react-parser"
import { HostingCategoriesList } from './hooks/hostingcategories'

const CategoriesSummary = props => {
  const { hostingcategories } = HostingCategoriesList()
  //console.log('hostingcategories=', hostingcategories)

  return (
  
    <React.Fragment key={"2222"}> 
     <h2>Web Hosting By Specialty</h2>

        {
          hostingcategories.filter((node) => node.node.hostingtypeid!==10)
          .map( (node,index)   => {
        //console.log("node=",node) 
        const categoryTitle = node.node.title.toLowerCase().trim();
        const removeStr = ' ' //variable
        const regex = new RegExp(removeStr, 'g') // correct way
        const categoryPath = categoryTitle.replace(regex, '-') // it works   
        
        return (
          <React.Fragment key={index}>
          <h3>{node.node.title}</h3>
          {node.node.metadescr} <br/>
          <Link
          to={`/${categoryPath}`}
          >
          List of {node.node.title}  <br/>  <br/>
        </Link>
          </React.Fragment>
          )        
        }  )
      }
    
     
    </React.Fragment>
  )
 
}

export default CategoriesSummary
